<template>
<el-row>
    <el-form ref="form" :model="courseSchedule" :rules="rules">
        <el-col :span="6">
            <el-form-item class="timepicker-col" prop="day" :label="courseSchedule.CourseName" label-width="150px">
            </el-form-item>
        </el-col>
        <el-col :span="18">
            <el-row v-for="(detail,rowIndex) in courseSchedule.TrainingCourseScheduleDetails" :key="detail.Guid" :name="detail.Guid">
                <el-col :span="7">
                    <el-form-item class="timepicker-col" prop="day">
                        <el-select v-model="detail.DayOfWeek" class="popup-input-width-range-multiple-col" placeholder="请选择" size="small">
                            <el-option v-for="item in daysOfWeekList" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="7">
                    <el-form-item class="timepicker-col" prop="startTime">
                        <el-select v-model="detail.StartTimeInt" class="popup-input-width-range-multiple-col" :clearable="true" size="small" placeholder="开始时间">
                            <el-option v-for="item in timesOfStartTime" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="7">
                    <el-form-item class="timepicker-col" prop="endTime">
                        <el-select v-model="detail.EndTimeInt" class="popup-input-width-range-multiple-col" :clearable="true" size="small" placeholder="结束时间">
                            <el-option v-for="item in timesOfEndTime" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="1">
                    <el-button class="timepicker-col-close" v-if="rowIndex==0" type="text" @click="addRow">
                        <i class="el-icon el-icon-plus"></i>
                    </el-button>
                    <el-button class="timepicker-col-close" v-if="rowIndex>0" type="text" @click="deleteRow(rowIndex)">
                        <i class="el-icon el-icon-close delete-row-icon"></i>
                    </el-button>
                </el-col>
            </el-row>
        </el-col>
    </el-form>
</el-row>
</template>

<script>
import {
    getTermYearList,
    getTermSeasonList,
    formatTimeToInt60,
    guid
} from "../../config/mUtils.js"
import {
    srcDaysOfWeek,
    srcTimesOfDay
} from "../../service/api-base.service";
export default {
    props: {
        dataIn: Object
    },
    data() {
        let startTimeValidator = (rule, value, callback) => {
            if (value === "") {
                return callback(new Error("请选择开始时间"));
            } else {
                return callback();
            }
        };
        let endTimeValidator = (rule, value, callback) => {
            if (value === "") {
                return callback(new Error("请选择结束时间"));
            } else {
                return callback();
            }
        };
        let dayValidator = (rule, value, callback) => {
            if (value === "") {
                return callback(new Error("请选择日期"));
            }
            return callback();
        }
        return {
            courseSchedule: {
                CourseId: 0,
                CourseName: "",
                TrainingCourseScheduleDetails: []
            },
            daysOfWeekList: srcDaysOfWeek(),
            timesOfStartTime: srcTimesOfDay(),
            timesOfEndTime: srcTimesOfDay(),
            rules: {
                day: [{
                    validator: dayValidator,
                    required: true,
                    trigger: "blur"
                }],
                startTime: [{
                    validator: startTimeValidator,
                    required: true,
                    trigger: "blur"
                }],
                endTime: [{
                    validator: endTimeValidator,
                    required: true,
                    trigger: "blur"
                }]
            }
        }
    },
    created() {
        this.init();
    },
    methods: {
        init() {
            this.courseSchedule = $.extend({}, this.dataIn);
        },
        addRow() {
            let schedule = {
                Guid: guid(),
                Id: 0,
                DayOfWeek: null,
                StartTimeInt: null,
                EndTimeInt: null,
            }
            this.courseSchedule.TrainingCourseScheduleDetails.push(schedule);
        },
        deleteRow(rowIndex) {
            let row = this.courseSchedule.TrainingCourseScheduleDetails[rowIndex];
            if (row.Id > 0) {
                this.$emit("deleteCourseSchedule", row.Id);
            }
            this.courseSchedule.TrainingCourseScheduleDetails.splice(rowIndex, 1);

        },
        validateCourseScheduleDetail() {
            let isValid = true;
            this.$refs.form.validate((valid) => {
                isValid &= valid;
            });
            return isValid;
        },
        getCourseScheduleDetailModel() {
            return this.courseSchedule;
        }
    },
    watch: {
        dataIn: function () {
            this.courseSchedule = $.extend({}, this.dataIn);
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/termManagement/trainingCourseScheduleEditor.vue